import React, {
  cloneElement,
  isValidElement,
  ReactElement,
  ReactNode,
} from "react";
import { CardContentInner } from "react-admin";
import { CompactFormToolbar } from "../CompactFormToolbar";
import { useFormContext } from "react-hook-form";
import { CompactSaveButton } from "../CompactSaveButton";
import "../../styles/form-style.css";

interface Props {
  children: ReactNode;
  toolbar?: ReactElement;
}

interface FormContentProps {
  children: ReactNode;
  variant?: "standard" | "outlined" | "filled";
}

const SimpleFormContent = ({ children, ...rest }: FormContentProps) => (
  <CardContentInner>
    {React.Children.map(children, (input) => {
      if (!isValidElement(input)) {
        return undefined;
      }

      return (
        <div className="ra-input">
          {cloneElement(input, {
            ...rest,
            variant: input.props.variant ?? rest.variant,
          })}
        </div>
      );
    })}
  </CardContentInner>
);

const DefaultCompactFormToolbar = () => {
  const {
    formState: { isSubmitting, isValid },
  } = useFormContext();
  return (
    <CompactFormToolbar>
      <CompactSaveButton
        saving={isSubmitting}
        disabled={isSubmitting || !isValid}
      />
    </CompactFormToolbar>
  );
};

export const HookFormSimpleForm = (props: Props) => {
  const { toolbar = <DefaultCompactFormToolbar />, children, ...rest } = props;

  return (
    <div>
      <SimpleFormContent {...sanitizeRestProps(rest)}>
        {children}
      </SimpleFormContent>
      {toolbar}
    </div>
  );
};

const sanitizeRestProps = ({
  active,
  dirty,
  dirtyFields,
  dirtyFieldsSinceLastSubmit,
  dirtySinceLastSubmit,
  error,
  errors,
  form,
  hasSubmitErrors,
  hasValidationErrors,
  initialValues,
  modified = null,
  modifiedSinceLastSubmit,
  save = null,
  submitError,
  submitErrors,
  submitFailed,
  submitSucceeded,
  submitting,
  touched = null,
  valid,
  values,
  visited = null,
  __versions = null,
  ...props
}: any) => props;
